import { Form, FormControl, Button } from 'react-bootstrap';

function Search(props) {
  return (
    <Form inline onSubmit={props.handleSearch}>
      <FormControl type="text" placeholder="Search tags" className="mr-sm-2 font-100" />
    </Form>
  );
}
export default Search